document.addEventListener('DOMContentLoaded', function() {
    var suggestionBlocks = document.querySelectorAll('.suggestion');

    suggestionBlocks.forEach(function(block) {
        var form = block.querySelector('.suggestion-form');
        var input = block.querySelector('.suggestion-input');
        var submitBtn = block.querySelector('.suggestion-submit-btn');
        var successMsg = block.querySelector('.suggestion-success');
        var singleSubmission = block.getAttribute('data-single-submission') === '1';

        if (!form || !input || !submitBtn) return;

        form.addEventListener('submit', function(e) {
            e.preventDefault();

            var postId = input.getAttribute('data-post-id');
            var suggestionId = input.getAttribute('data-suggestion-id');
            var response = input.value.trim();

            if (!postId || !suggestionId || !response) return;

            submitBtn.disabled = true;
            submitBtn.classList.add('processing');
            var originalText = submitBtn.textContent;
            submitBtn.textContent = 'Sender...';

            var data = new FormData();
            data.append('action', 'suggestion_response');
            data.append('post_id', postId);
            data.append('suggestion_id', suggestionId);
            data.append('response', response);
            data.append('security', feltpost_scripts.nonce);

            $.ajax({
                url: feltpost_scripts.ajax_url,
                type: 'POST',
                data: data,
                cache: false,
                processData: false,
                contentType: false,
                error: function(error) {
                    console.error('Error submitting suggestion', error);
                    submitBtn.disabled = false;
                    submitBtn.classList.remove('processing');
                    submitBtn.textContent = originalText;
                },
                success: function(ajaxResponse) {
                    submitBtn.disabled = false;
                    submitBtn.classList.remove('processing');

                    if (ajaxResponse.success) {
                        if (singleSubmission) {
                            // Replace form with the submitted response
                            var respondedHtml = '<div class="suggestion-already-responded">';
                            respondedHtml += '<p class="suggestion-already-responded-label">Ditt svar:</p>';
                            respondedHtml += '<p class="suggestion-already-responded-text">' + response.replace(/</g, '&lt;').replace(/>/g, '&gt;') + '</p>';
                            respondedHtml += '</div>';
                            form.outerHTML = respondedHtml;
                            if (successMsg) {
                                successMsg.style.display = 'block';
                            }
                        } else {
                            input.value = '';
                            submitBtn.textContent = 'Sendt!';
                            if (successMsg) {
                                successMsg.style.display = 'block';
                            }
                            setTimeout(function() {
                                submitBtn.textContent = originalText;
                                if (successMsg) {
                                    successMsg.style.display = 'none';
                                }
                            }, 3000);
                        }
                    } else {
                        console.error('Error in response', ajaxResponse);
                        submitBtn.textContent = originalText;
                    }
                }
            });
        });
    });
});
